import { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import { logout } from './actions/login';



class LoginLayout extends Component {
	render () {
		return ''
	}
	
	componentWillMount() {
		this.props.logout();
	}
}


const mapStateToProps = (state) => {
	const { userLogin } = state;
	return {
		userLogin
	}
}

const mapDispatchToProps = dispatch => {
	return {
		logout: () => {
			dispatch(logout());
		}
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginLayout));


// WEBPACK FOOTER //
// ./src/logoutapp.js